import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import {
    HiMapPin,
    HiBriefcase,
    HiRocketLaunch
} from "react-icons/hi2";

const JobDetails = () => {
    const { slug } = useParams();
    const [job, setJob] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        location: "",
        experience: "",
        about: "",
    });

    const [resume, setResume] = useState(null);

    useEffect(() => {
        fetch(
            `https://appverselabs.codebuddys.in/wp-json/wp/v2/awsm_job_openings?slug=${slug}`
        )
            .then((res) => res.json())
            .then((data) => {
                if (data.length > 0) {
                    setJob(data[0]);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }, [slug]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setSubmitting(true);

        try {
            const payload = new FormData();

            payload.append("name", formData.name);
            payload.append("email", formData.email);
            payload.append("phone", formData.phone);
            payload.append("location", formData.location);
            payload.append("experience", formData.experience);
            payload.append("about", formData.about);
            payload.append("job_title", job.title.rendered);

            if (resume) {
                payload.append("resume", resume);
            }

            const response = await fetch(
                "https://appverselabs.codebuddys.in/wp-json/careers/v1/apply",
                {
                    method: "POST",
                    body: payload,
                }
            );

            const result = await response.json();

            if (result.success) {
                alert("Application Submitted Successfully");

                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    location: "",
                    experience: "",
                    about: "",
                });

                setResume(null);
            }
        } catch (err) {
            console.log(err);
            alert("Submission Failed");
        }

        setSubmitting(false);
    };

    if (loading) {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "24px",
                    fontWeight: "700",
                }}
            >
                Loading Position...
            </div>
        );
    }

    if (!job) {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "24px",
                    fontWeight: "700",
                }}
            >
                Job Not Found
            </div>
        );
    }

    const locationClass = job.class_list?.find((item) =>
        item.startsWith("job-location-")
    );

    const typeClass = job.class_list?.find((item) =>
        item.startsWith("job-type-")
    );

    const location = locationClass
        ? locationClass
            .replace("job-location-", "")
            .replace(/-/g, " ")
        : "Remote";

    const jobType = typeClass
        ? typeClass
            .replace("job-type-", "")
            .replace(/-/g, " ")
        : "Full Time";

    return (
        <>
            <Header />

            <section className="job-page">

                <div className="job-hero">
                    <span className="job-badge">
                        WE ARE HIRING
                    </span>

                    <h1>
                        {job.title.rendered}
                    </h1>

                    <div className="job-tags">

                        <div className="job-tag">
                            <HiMapPin className="job-tag-icon" />
                            {location}
                        </div>

                        <div className="job-tag">
                            <HiBriefcase className="job-tag-icon" />
                            {jobType}
                        </div>

                        <div className="job-tag">
                            <HiRocketLaunch className="job-tag-icon" />
                            Immediate Joiner
                        </div>

                    </div>
                </div>

                <div className="job-wrapper">

                    <div className="content-card">
                        <h2>
                            Job Description
                        </h2>

                        <div
                            className="job-html"
                            dangerouslySetInnerHTML={{
                                __html: job.content.rendered,
                            }}
                        />
                    </div>

                    <div className="apply-card">

                        <h3>
                            Apply For This Position
                        </h3>

                        <p>
                            Join our talented team and
                            build amazing products.
                        </p>

                        <form onSubmit={handleSubmit}>

                            <input
                                type="text"
                                name="name"
                                placeholder="Full Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />

                            <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />

                            <input
                                type="tel"
                                name="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />

                            <input
                                type="text"
                                name="location"
                                placeholder="Current Location"
                                value={formData.location}
                                onChange={handleChange}
                            />

                            <input
                                type="text"
                                name="experience"
                                placeholder="Years of Experience"
                                value={formData.experience}
                                onChange={handleChange}
                            />

                            <div className="resume-box">
                                <label>
                                    Upload Resume
                                </label>

                                <input
                                    type="file"
                                    accept=".pdf,.doc,.docx"
                                    onChange={(e) =>
                                        setResume(
                                            e.target.files[0]
                                        )
                                    }
                                />
                            </div>

                            <textarea
                                rows="5"
                                name="about"
                                placeholder="Tell us about yourself..."
                                value={formData.about}
                                onChange={handleChange}
                            />

                            <button
                                type="submit"
                                disabled={submitting}
                            >
                                {submitting
                                    ? "Submitting..."
                                    : "Apply Now →"}
                            </button>

                        </form>

                    </div>

                </div>
            </section>

            <Footer />

            <style>{`
                .job-page{
    padding:140px 20px 80px;
    background:#fafafa;
}
.job-tags{
    display:flex;
    flex-wrap:wrap;
    gap:12px;
}

.job-tag{
    display:flex;
    align-items:center;
    gap:8px;

    padding:10px 16px;

    border-radius:50px;

    background:#fff5f5;
    border:1px solid rgba(232,33,42,.12);

    color:#444;
    font-size:14px;
    font-weight:600;

    transition:.3s ease;
}

.job-tag:hover{
    background:#E8212A;
    color:#fff;
    transform:translateY(-2px);
}

.job-tag-icon{
    font-size:16px;
    color:#E8212A;
}

.job-tag:hover .job-tag-icon{
    color:#fff;
}
.job-hero{
    max-width:1300px;
    margin:auto;
    margin-bottom:50px;
}

.job-badge{
    display:inline-block;
    padding:10px 20px;
    border-radius:999px;
    background:rgba(232,33,42,.08);
    color:#E8212A;
    font-weight:700;
    margin-bottom:20px;
}

.job-hero h1{
    font-size:60px;
    margin-bottom:20px;
    font-family:'Syne',sans-serif;
    line-height:1.1;
}

.job-tags{
    display:flex;
    flex-wrap:wrap;
    gap:12px;
}

.job-tag{
    padding:12px 18px;
    border-radius:999px;
    background:#fff;
    border:1px solid #eee;
}

.job-wrapper{
    max-width:1300px;
    margin:auto;
    display:grid;
    grid-template-columns:1.7fr .9fr;
    gap:40px;
    align-items:start;
}

/* LEFT CONTENT */

.content-card{
    background:#fff;
    padding:40px;
    border-radius:24px;
    box-shadow:0 10px 40px rgba(0,0,0,.05);
}

.content-card h2{
    font-size:34px;
    margin-bottom:25px;
    color:#111;
    font-family:'Syne',sans-serif;
}

.job-html{
    line-height:1.9;
    color:#444;
    font-size:16px;
}

.job-html h2,
.job-html h3,
.job-html h4{
    margin-top:35px;
    margin-bottom:15px;
    color:#111;
}

.job-html ul{
    padding-left:22px;
}

.job-html li{
    margin-bottom:10px;
}

/* RIGHT SIDEBAR */

.apply-card{
    position:sticky;
    top:120px;
    align-self:start;
    height:fit-content;

    background:#fff;
    padding:35px;
    border-radius:24px;
    box-shadow:0 15px 50px rgba(0,0,0,.08);
}

.apply-card h3{
    font-size:30px;
    margin-bottom:10px;
    color:#111;
    font-family:'Syne',sans-serif;
}

.apply-card p{
    color:#666;
    margin-bottom:25px;
    line-height:1.7;
}

.apply-card form{
    display:flex;
    flex-direction:column;
    gap:15px;
}

.apply-card input,
.apply-card textarea{
    width:100%;
    padding:16px;
    border:1px solid #e6e6e6;
    outline:none;
    font-size:15px;
    transition:.3s;
    background:#fff;
}

.apply-card input:focus,
.apply-card textarea:focus{
    border-color:#E8212A;
    box-shadow:0 0 0 4px rgba(232,33,42,.08);
}

.resume-box{
    padding:15px;
    border:1.5px dashed #ddd;
    border-radius:14px;
    background:#fafafa;
}

.resume-box label{
    display:block;
    margin-bottom:10px;
    font-weight:600;
    color:#111;
}

.resume-box input{
    border:none;
    padding:0;
    background:none;
}

.apply-card textarea{
    resize:none;
}

.apply-card button{
    border:none;
    padding:18px;
    border-radius:14px;
    background:linear-gradient(
        135deg,
        #E8212A,
        #FF4D4D
    );
    color:#fff;
    font-size:16px;
    font-weight:700;
    cursor:pointer;
    transition:.3s;
    box-shadow:
        0 15px 35px rgba(232,33,42,.25);
}

.apply-card button:hover{
    transform:translateY(-3px);
}

.apply-card button:disabled{
    opacity:.7;
    cursor:not-allowed;
}

/* TABLETS */

@media(max-width:991px){

    .job-wrapper{
        grid-template-columns:1fr;
    }

    .apply-card{
        position:relative;
        top:auto;
    }
}

/* MOBILE */

@media(max-width:768px){

    .job-page{
        padding:110px 15px 60px;
    }

    .job-hero h1{
        font-size:40px;
    }

    .content-card,
    .apply-card{
        padding:25px;
    }

    .content-card h2{
        font-size:28px;
    }

    .apply-card h3{
        font-size:24px;
    }

    .job-tags{
        gap:8px;
    }

    .job-tag{
        font-size:13px;
        padding:10px 14px;
    }
}
            `}</style>
        </>
    );
};

export default JobDetails;